<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="d-flex justify-content-between">
        <div class="section-title">
          {{ $t("Cashier Settlement Report") }}
        </div>
        <div class="d-flex align-items-center">
          <div class="d-flex align-item-center">
            <input value="1" type="radio" v-model="lang_id" />
            <span class="ml-1">English</span>
          </div>
          <div class="d-flex align-item-center ml-2">
            <input value="2" type="radio" v-model="lang_id" />

            <span class="ml-1">العربية</span>
          </div>
        </div>
      </div>
      <small
        ><em>{{ $t("* As Per Transaction Date") }}</em></small
      >
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.selectedCinema &&
                  dropDown.selectedCinema.hasOwnProperty('cine_id')
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{ $t("select") }} {{ $tc("cinema") }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder=""
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                              ✖
                            </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                  :disabled-dates="disablePastDates"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                  :disabled="true"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedUsers && selectedUsers.length > 0
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{ $t("select") }} {{ $t("users") }}</label
              >
              <multiselect
                :options="Users"
                v-model="selectedUsers"
                placeholder=""
                label="username"
                :multiple="true"
                :close-on-select="true"
                track-by="user_id"
              ></multiselect>
            </div>
          </div>

          <!-- show time filter -->
          <div class="position-relative col-lg-3 col-xl-2 mb-2">
            <vue-timepicker
              manual-input
              v-model="start_time"
              id="starttime"
              name="starttime"
              :placeholder="$tc('starttime')"
              format="HH:mm"
              class="time_picker"
              input-width="100%"
              auto-scroll
              lazy
            ></vue-timepicker>
          </div>

          <div class="position-relative col-lg-3 col-xl-2 mb-2">
            <vue-timepicker
              manual-input
              v-model="end_time"
              id="endtime"
              name="endtime"
              :placeholder="$tc('endtime')"
              format="HH:mm"
              class="time_picker"
              input-width="100%"
              auto-scroll
              lazy
            />
          </div>
          <!-- show time filter -->

          <div class="col-12 col-md-6 col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onSubmit">
              {{ $t("fetch") }}
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="showData.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} {{ $t("as") }}</div>

        <img
          @click="getCashierSettlementReport('Y', 'N')"
          class="cursor-pointer"
          height="25"
          src="@/assets/img/icons/pdf-icon.svg"
          width="25"
        />

        <img
          @click="getCashierSettlementReport('N', 'Y')"
          class="cursor-pointer ml-1"
          height="25"
          src="@/assets/img/icons/excel.svg"
          width="25"
        />
      </div>

      <div class="swc-report">
        <table
          class="swc-report-table"
          :class="
            lang_id == 2
              ? 'swc-report-table reverse-order'
              : 'swc-report-table order'
          "
          border="1"
        >
          <tbody v-if="showData.length">
            <!-- User Loop -->
            <template v-for="(userBlock, userIndex) in showData">
              <!-- Username Header -->
              <tr class="text-white" style="background-color: skyblue">
                <td
                  :colspan="7"
                  :class="lang_id == 1 ? 'text-left' : 'text-right'"
                >
                  <strong>{{ userBlock.username }}</strong>
                </td>
              </tr>

              <!-- Column Header -->
              <tr class="bg-lightgrey">
                <th>{{ trans("showtimes", lang_id) }}</th>
                <th>{{ trans("movie", lang_id) }}</th>
                <th>{{ trans("paymentmethods", lang_id) }}</th>
                <th>{{ trans("tickets", lang_id) }}</th>
                <th>{{ trans("ticketsrevenue", lang_id) }}</th>
                <th>{{ trans("3dglasses", lang_id) }}</th>
                <th>{{ trans("3dglassesrevenue", lang_id) }}</th>
              </tr>

              <!-- Show Groups -->
              <template v-for="(showGroup, sgIndex) in userBlock.showGroups">
                <template v-for="(movieData, mIndex) in showGroup.shows">
                  <template
                    v-for="(
                      scheduleData, sIndex
                    ) in movieData.schedule_show_data"
                  >
                    <template
                      v-for="(payment, pIndex) in scheduleData.paymentData"
                    >
                      <tr>
                        <!-- Show DateTime -->
                        <td
                          v-if="mIndex === 0 && sIndex === 0 && pIndex === 0"
                          :rowspan="
                            showGroup.shows.reduce(
                              (sum, md) =>
                                sum +
                                md.schedule_show_data.reduce(
                                  (subSum, s) => subSum + s.paymentData.length,
                                  0
                                ) +
                                md.show_total.length,
                              0
                            )
                          "
                          class="text-left"
                        >
                          {{ showGroup.show_datetime }}
                        </td>

                        <!-- Movie Title -->
                        <td
                          v-if="sIndex === 0 && pIndex === 0"
                          :rowspan="movieData.schedule_show_data.reduce((sum, s) => sum + s.paymentData.length, 0)"
                          
                          class="text-left"
                        >
                          {{
                            lang_id == 1
                              ? movieData.movie_title
                              : movieData.movie_title_2 || movieData.movie_title
                          }}
                        </td>

                        <!-- Payment Info -->
                        <td class="text-left">{{ payment.pm_payment_mode }}</td>
                        <td class="text-right">{{ payment.tickets_no }}</td>
                        <td class="text-right">{{ payment.tickets_gross }}</td>
                        <td class="text-right">
                          {{ payment.total_3d_tickets }}
                        </td>
                        <td class="text-right">
                          {{ payment.total_3d_charge }}
                        </td>
                      </tr>
                    </template>
                  </template>

                  <!-- Movie Totals -->
                  <tr
                    class="blue-background"
                    v-for="(movieTotal, tIndex) in movieData.show_total"
                    :key="'movie-total-' + tIndex"
                  >
                    <td
                      v-if="tIndex === 0"
                      :rowspan="movieData.show_total.length"
                      class="text-left"
                    >
                      ({{ trans("total", lang_id) }})
                      {{
                        lang_id == 1
                          ? movieData.movie_title
                          : movieData.movie_title_2 || movieData.movie_title
                      }}
                      <br />
                      <span class="text-muted">Without(Invitation,Online)</span>
                    </td>
                    <td class="text-left">{{ movieTotal.payment_mode }}</td>
                    <td class="text-right">{{ movieTotal.total_tickets }}</td>
                    <td class="text-right">{{ movieTotal.tickets_gross }}</td>
                    <td class="text-right">{{ movieTotal.tickets_no_3d }}</td>
                    <td class="text-right">
                      {{ movieTotal.tickets_gross_3d }}
                    </td>
                  </tr>
                </template>

                <!-- Show Group Total -->
                <tr
                  class="dark-blue font-weight-bold"
                  v-for="(totalRow, gIndex) in showGroup.grandTotal"
                  :key="'show-group-grand-total-' + gIndex"
                >
                  <td
                    v-if="gIndex === 0"
                    colspan="2"
                    :rowspan="showGroup.grandTotal.length"
                    :class="lang_id == 1 ? 'text-left' : 'text-right'"
                  >
                    <b
                      >({{ trans("total", lang_id) }})
                      {{ showGroup.show_datetime }}</b
                    >
                    <br />
                    <span class="text-muted">Without(Invitation,Online)</span>
                  </td>
                  <td class="text-left">{{ totalRow.payment_mode }}</td>
                  <td class="text-right">{{ totalRow.total_tickets }}</td>
                  <td class="text-right">{{ totalRow.total_tickets_gross }}</td>
                  <td class="text-right">{{ totalRow.total_3d_tickets }}</td>
                  <td class="text-right">{{ totalRow.total_3d_charge }}</td>
                </tr>
              </template>

              <!-- User Grand Total -->
              <tr
                class="font-weight-bold"
                style="background-color: #afdbf5"
                v-for="(totalRow, ugIndex) in userBlock.userGrandTotal"
                :key="'user-grand-total-' + ugIndex"
              >
                <td
                  v-if="ugIndex === 0"
                  colspan="2"
                  :rowspan="userBlock.userGrandTotal.length"
                  :class="lang_id == 1 ? 'text-left' : 'text-right'"
                >
                  <b
                    >({{ trans("total", lang_id) }}) {{ userBlock.username }}</b
                  >
                  <br />
                  <span class="text-muted">Without(Invitation,Online)</span>
                </td>
                <td class="text-left">{{ totalRow.payment_mode }}</td>
                <td class="text-right">{{ totalRow.total_tickets }}</td>
                <td class="text-right">{{ totalRow.total_tickets_gross }}</td>
                <td class="text-right">{{ totalRow.total_3d_tickets }}</td>
                <td class="text-right">{{ totalRow.total_3d_charge }}</td>
              </tr>

              <tr>
                <td colspan="7" style="height: 30px; border: none"></td>
              </tr>
            </template>

            <!-- Final Grand Total -->
            <tr
              class="dark-blue font-weight-bold"
              v-for="(totalRow, gTotalIndex) in grandTotal"
              :key="'grand-total-' + gTotalIndex"
            >
              <td
                v-if="gTotalIndex === 0"
                colspan="2"
                :rowspan="grandTotal.length"
                class="text-left"
              >
                <b>{{ trans("grandtotal", lang_id) }}</b>
                <br />
                <span class="text-muted">Without(Invitation,Online)</span>
              </td>
              <td class="text-left">{{ totalRow.payment_mode }}</td>
              <td class="text-right">{{ totalRow.total_tickets }}</td>
              <td class="text-right">{{ totalRow.total_tickets_gross }}</td>
              <td class="text-right">{{ totalRow.total_3d_tickets }}</td>
              <td class="text-right">{{ totalRow.total_3d_charge }}</td>
            </tr>
          </tbody>

          <!-- No Records Fallback -->
          <tbody v-else>
            <tr>
              <td colspan="7">No Records</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import NewReportService from "../../../services/NewReportService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";
import { mapState, mapActions } from "vuex";
// import LangSwitcher from "./LangSwitcher.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
    // LangSwitcher,
    VueTimepicker,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCinemaAddres: null,
      },
      fromDate: new Date(),
      toDate: new Date(),
      advancedSalesrecords: [],
      grandTotal: {},
      screenData: [],
      showData: [],
      Users: [],
      selectedScreen: [],
      selectedUsers: [],
      screenList: [],
      selectedLanguage: "en",
      lang_id: "1",
      end_time: "",
      start_time: "",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    this.getUsers();
  },
  watch: {},
  mounted() {},
  computed: {
    currentSelectedLanguage() {
      return this.$store.getters.GET_SELECTED_HEADER_LANGUAGE;
    },
    disablePastDates() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      return {
        from: tomorrow,
      };
    },
  },
  methods: {
    moment,
    onChangeDate: function (e, type) {
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.dropDown.selectedCinemaAddres = event.cine_address;
      this.$store.dispatch("selectDropdownCinema", event);
      // this.getCinemaScreens();
    },
    onSubmit() {
      this.getCashierSettlementReport();
    },
    async getCinemaScreens(index) {
      try {
        const response = await MasterService.GetActiveList({
          tableName: "screens",
          screen_is_active: "Y",
          cinema_id: this.dropDown.selectedCinemaId,
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.screenList = data.Records;
        } else {
          console.log("show error:", data.message);
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    async getUsers(index) {
      try {
        const response = await MasterService.GetActiveList({
          tableName: "users",
          is_active: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.Users = data.Records.filter((user) => user.role_id == 4);
          // console.log("Users",this.Users)
        } else {
          console.log("show error:", data.message);
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    async getCashierSettlementReport(isPdf = "N", isExcel = "N") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      this.showData = [];
      this.grandTotal = {};
      let loader;
      try {
        let user_id = [];
        if (this.selectedUsers.length) {
          user_id = this.selectedUsers.map((user_ids) => ({
            user_id: user_ids.user_id,
            username: user_ids.username,
          }));
        }
        //console.log("user_id",user_id)
        loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName,
          cinema_address: this.dropDown.selectedCinemaAddres,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isPdf,
          isExcel,
          lang_id: this.lang_id,
          language: this.selectedLanguage,
          start_time: this.start_time,
          end_time: this.end_time,
          user_id: user_id.map((p) => p.user_id),
          username: user_id.map((p) => p.username),
        };
        // console.log("payload", payload)
        // if(this.selectedUsers && this.selectedUsers.user_id){
        //   payload.user_id=this.selectedUsers.user_id
        // }
        let response = await NewReportService.getCashierSettlementReport(
          payload
        );
        const { data } = response;
        if (data.status && data.Records.length) {
          this.showData = data.Records;
          this.grandTotal = data.grandTotal;
          if (isPdf == "Y" && data.pdfPath) {
            window.open(data.pdfPath, "_blank");
          }
          if (isExcel == "Y" && data.excelPath) {
            window.open(data.excelPath, "_blank");
          }
        } else {
          this.$toasted.show(data.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    updateLanguage(lang) {
      this.selectedLanguage = lang;
      // console.log("this.selectedLanguage:", this.selectedLanguage);
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}
.rtl-table {
  direction: rtl;
  text-align: right;
}
.rtl-table-scroll {
  direction: rtl;
}
.text_right {
  text-align: right;
}
.reverse-order {
  direction: rtl;
}
.order {
  direction: ltr;
}
.blue-background {
  background-color: #edf3fb;
}
.dark-blue {
  background-color: #d4e3f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/cashierSettlementReport.vue